import { useContext } from 'react';
import { FabricContext } from '../contexts/FabricContext';

const useFabricContext = () => {
  const context = useContext(FabricContext);

  if (!context) {
    throw new Error('useFabricContext must be used within a FabricContextProvider');
  }

  return context;
};

export default useFabricContext;
